module.exports = __webpack_public_path__ + "img/tableau-recap-v1.353f6e31.png";